export default __webpack_public_path__ + "static/media/1.8df34825.png";